const securityWorker = (securityData) => {
    if (!securityData?.userToken) {
        return;
    }
    return { headers: { Authorization: `Bearer ${securityData?.userToken}` } };
};
export default securityWorker;
